<template>
  <div class="confirm-form">
    <div class="form-group">
      <h4 class="text-center" for="storage-amount">{{ inputLabel }}</h4>
      <h6 v-if="inputLabel === '更新安全存量'">
        目前此藥物還有數量 <strong>{{ $store.state.drug.selectedDrugTotalAmount }}</strong> 在藥櫃中
      </h6>
      <h6 v-if="inputLabel === '更新安全存量'">
        (總最大庫存數量 <strong>{{ $store.state.drug.selectedDrugTotalMax }}</strong>)
      </h6>
      <input 
        class="form-control custom-input" 
        type="number" id="storage-amount" 
        v-model="storageAmount" min="0" 
        @click="showPad = true"
        @keydown="showPad = true"
        ref="input" />
      <transition name="fade"> 
        <NumberInput v-if="showPad" v-on:saveNumber="saveNumber" :defaultNumber="storageAmount"/>
      </transition>
    </div>
    <div class="button-wrap">
      <button class="btn btn-lg confirm-button" @click="setNum">確認</button>
    </div>
  </div>
</template>

<script>
import NumberInput from './NumberInput';

export default {
  name: 'NumberSet',
  props: {
    maxAmount: Number,
    defaultAmount: Number,
    inputLabel: String,
    canBeZero: Boolean,
  },
  components: {
    NumberInput,
  },
  data() {
    return {
      storageAmount: 0,
      showPad: false,
    };
  },
  mounted() {
    this.storageAmount = this.defaultAmount;
    if (this.maxAmount) this.storageAmount = this.maxAmount;
    this.$refs.input.focus();
  },
  watch: {
    storageAmount(val) {
      if (isNaN(val)) {
        this.storageAmount = 0;
      } else {
        this.storageAmount = parseInt(val, 10);
      }
    },
    defaultAmount() {
      this.storageAmount = this.defaultAmount;
    },
  },
  computed: {
    currentApp() {
      return this.$store.state.currentApp;
    },
  },
  methods: {
    setNum() {
      if (this.maxAmount) {
        console.log(this.storageAmount > this.maxAmount);
        if (this.storageAmount > this.maxAmount) {
          this.$store.commit('SET_MESSAGE', { type: 'error', context: `設定數量不可大於最大庫存量 (${this.MaxAmount}).` });
        } else if (this.storageAmount === 0) {
          if (this.canBeZero) {
            this.$emit('setNum', this.storageAmount);
          } else {
            this.$store.commit('SET_MESSAGE', { type: 'error', context: '數量不可為0' });
          }
        } else {
          this.$emit('setNum', this.storageAmount);
        }
      } else {
        if (this.storageAmount === 0) {
          if (this.canBeZero) {
            this.$emit('setNum', this.storageAmount);
          } else {
            this.$store.commit('SET_MESSAGE', { type: 'error', context: '數量不可為0' });
          }
        } else {
          this.$emit('setNum', this.storageAmount);
        }
      }
    },
    saveNumber(val) {
      this.storageAmount = val;
      this.showPad = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// NumberSet.vue?6fb85375